import { toast } from 'react-toastify';

export function Alert(msg, type = '', opts){
    var optsDef = {
        ...opts,
        position: "top-center",
        autoClose: 8000,
        theme: 'colored'
    }

    const notifyval = () => {
        switch (type) {
            case 'error':
                toast.error(msg, optsDef);
                break;
            case 'info':
                toast.info(msg, optsDef);
                break;
            case 'success':
                toast.success(msg, optsDef);
                break;
            case 'warning':
                toast.warn(msg, optsDef);
                break;
            default:
                toast(msg, optsDef);
                break;
        }
    }
    notifyval();
}